import * as React from 'react';
const EmptyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76}
    height={76}
    fill="none"
    {...props}
  >
    <path
      fill="#F8F8F8"
      d="M38 76c20.987 0 38-17.013 38-38S58.987 0 38 0 0 17.013 0 38s17.013 38 38 38Z"
    />
    <g filter="url(#a)">
      <path
        fill="url(#b)"
        d="M24.138 20.838a3 3 0 0 1 3-3h13.036a3 3 0 0 1 2.313 1.09l9.464 11.456a3 3 0 0 1 .687 1.91v19.768a3 3 0 0 1-3 3h-22.5a3 3 0 0 1-3-3V20.838Z"
      />
      <path
        stroke="url(#c)"
        d="M24.638 20.838a2.5 2.5 0 0 1 2.5-2.5h13.036a2.5 2.5 0 0 1 1.927.908l9.464 11.456a2.5 2.5 0 0 1 .573 1.592v19.768a2.5 2.5 0 0 1-2.5 2.5h-22.5a2.5 2.5 0 0 1-2.5-2.5V20.838Z"
      />
    </g>
    <g filter="url(#d)">
      <path
        fill="url(#e)"
        d="m46.821 24.133-5.816-6.295v10.377a3 3 0 0 0 3 3h8.633l-5.817-7.082Z"
      />
      <path
        stroke="url(#f)"
        strokeWidth={0.5}
        d="M52.109 30.965h-8.104a2.75 2.75 0 0 1-2.75-2.75v-9.738l5.378 5.82 5.476 6.668Z"
      />
    </g>
    <rect
      width={16.286}
      height={2.327}
      x={29.954}
      y={41.685}
      fill="#C9C9CC"
      rx={1.163}
    />
    <rect
      width={9.306}
      height={2.327}
      x={33.443}
      y={37.031}
      fill="#000"
      rx={1.163}
    />
    <defs>
      <linearGradient
        id="b"
        x1={38.388}
        x2={38.388}
        y1={17.838}
        y2={55.062}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#EFEFEF" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={38.097}
        x2={38.097}
        y1={55.062}
        y2={19.583}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={40.229}
        x2={46.049}
        y1={31.215}
        y2={31.98}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAFAFA" />
        <stop offset={1} stopColor="#EDEDED" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={47.984}
        x2={47.186}
        y1={39.085}
        y2={24.921}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter
        id="a"
        width={40.5}
        height={49.225}
        x={18.138}
        y={14.838}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7362_15926"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend
          in2="effect1_dropShadow_7362_15926"
          result="effect2_dropShadow_7362_15926"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend
          in2="effect2_dropShadow_7362_15926"
          result="effect3_dropShadow_7362_15926"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_7362_15926"
          result="shape"
        />
      </filter>
      <filter
        id="d"
        width={15.633}
        height={18.127}
        x={39.005}
        y={17.088}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7362_15926"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
        <feBlend
          in2="effect1_dropShadow_7362_15926"
          result="effect2_dropShadow_7362_15926"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.25} />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
        <feBlend
          in2="effect2_dropShadow_7362_15926"
          result="effect3_dropShadow_7362_15926"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_7362_15926"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default EmptyIcon;
